export const ca = {
  'ad.label': 'Publicitat',
  'ad.sponsored_by': 'Patrocinat per {advertiser}',
  'ad.visit': 'Visita',
  'cookies.preferences': 'Preferències de cookies',
  'cookies.title': 'La teva privacitat, sota el teu control',
  'cookies.description': 'Utilitzem emmagatzematge necessari perquè Albambam funcioni. Només activarem analítica o màrqueting si ens dones permís. Pots retirar-lo en qualsevol moment. Consulta la',
  'cookies.privacy_link': 'Política de Privacitat',
  'cookies.close': 'Tancar preferències',
  'cookies.necessary': 'Necessàries',
  'cookies.necessary_desc': 'Sessió, seguretat, idioma i preferències bàsiques.',
  'cookies.analytics': 'Analítica',
  'cookies.analytics_desc': 'Mesura anònima d’ús per millorar el servei.',
  'cookies.marketing': 'Màrqueting',
  'cookies.marketing_desc': 'Personalització publicitària i mesura de campanyes.',
  'cookies.configure': 'Configurar',
  'cookies.reject': 'Rebutjar opcionals',
  'cookies.save': 'Desar selecció',
  'cookies.accept': 'Acceptar totes',
  'lang.selector_label': 'Idioma',
  'lang.changed': 'Idioma canviat',
  'nav.home': 'Inici',
  'nav.categories': 'Categories',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Amistat',
  'nav.upload': 'Pujar',
  'nav.profile': 'Perfil',
  'nav.login': 'Entra',
  'common.signed_in': 'Sessió iniciada',
  'common.error': 'Error',
  'topbar.search_placeholder': 'Cerca vídeos, creadors...',
  'legal.terms': 'Termes',
  'legal.privacy': 'Privacitat',
  'nav.admin': 'Administració',
  'nav.logout': 'Tanca sessió',
  'admin.tab.payments': 'Cobraments',
  'admin.payments.title': 'Cobraments',
  'cats.title': 'Categories',
  'cats.all': 'Tots',
  'cats.adult_title': 'Categories +18',
  'cats.empty': 'Cap vídeo en aquesta categoria.',
  'friends.block_confirm': 'Bloquejar aquest amic? Ja no podreu xatejar ni vestos com a amics.',
  'friends.accepted': 'Ara sou amics!',
  'friends.title': 'Amistat',
  'friends.subtitle': 'Només qui es segueix mútuament esdevé amic i pot xatejar en privat.',
  'friends.unread_count_label': '{n} missatges per llegir',
  'friends.blocked_users_title': 'Usuaris bloquejats',
  'friends.unblock_user': 'Desbloquejar',
  'friends.requests_title': 'Sol·licituds de xat',
  'friends.request_badge': 'Sol·licitud',
  'friends.request_accept': 'Acceptar',
  'friends.request_ignore': 'Ignorar',
  'friends.empty_title': 'Encara no tens amics',
  'friends.empty_subtitle': 'Segueix algú i que et segueixi de tornada per desbloquejar el xat privat.',
  'friends.attach_image': 'Foto',
  'friends.shared_video_label': 'Ha compartit un vídeo',
  'friends.select_conversation': 'Selecciona un amic per començar a xatejar',
  'friends.block_user': 'Bloquejar',
  'friends.no_messages_yet': 'Encara no hi ha missatges. Saluda!',
  'friends.message_placeholder': 'Escriu un missatge...',
  'section.trending': 'Tendències',
  'section.shorts': 'Shorts',
  'section.for_you': 'Per a tu',
  'home.hero.badge': 'Benvinguts a Albambam',
  'home.hero.title_1': 'Vídeos curts.',
  'home.hero.title_2': 'Creadors reals.',
  'home.hero.subtitle': 'Mira, comparteix i guanya. Puja els teus vídeos i descobreix nous talents en cada categoria.',
  'home.hero.cta_shorts': 'Veure Shorts',
  'home.hero.cta_trending': 'Tendències',
  'home.shorts.see_all': 'Veure tots',
  'home.empty.title': 'Encara no hi ha vídeos',
  'home.empty.subtitle': 'Quan els creadors pugin contingut, apareixerà aquí.',
  'live.send_diamonds': 'Enviar diamants',
  'live.buy': 'Comprar',
  'live.chat': 'Xat',
  'live.type_message': 'Escriu un missatge...',
  'live.send': 'Enviar',
  'auth.success_google': 'Sessió iniciada amb Google',
  'auth.fail_google': 'Sessió de Google no vàlida',
  'auth.success_login': 'Sessió iniciada',
  'auth.success_register': 'Compte creat',
  'auth.login_tab': 'Entra',
  'auth.register_tab': 'Crea compte',
  'auth.email': 'Correu electrònic',
  'auth.password': 'Contrasenya',
  'auth.submit_login_loading': 'Entrant...',
  'auth.submit_login': 'Entra',
  'auth.name': 'Nom',
  'auth.submit_register_loading': 'Creant...',
  'auth.submit_register': 'Crea compte',
  'auth.or': 'o',
  'legal.privacy_title': 'Política de Privacitat',
  'search.title': 'Resultats per a “{q}”',
  'search.count': '{n} vídeos',
  'search.empty': 'Sense resultats.',
  'series.load_error': 'No s’ha pogut carregar la sèrie',
  'series.unlocked': 'Sèrie desbloquejada',
  'series.purchase_error': 'No s’ha pogut iniciar la compra',
  'series.restricted': 'Accés restringit',
  'series.configure_access': 'Configurar accés',
  'series.language_all': 'Tots els idiomes',
  'series.episode_count': '{n} episodis',
  'series.buy': 'Comprar sèrie',
  'series.filter_language': 'Filtrar per idioma',
  'series.no_episodes': 'Encara no hi ha episodis publicats.',
  'series.episode_number': 'Episodi {n}',
  'legal.terms_title': 'Termes i Condicions',
  'lang.ca': 'Català',
  'lang.en': 'Anglès',
  'lang.es': 'Castellà',
  'lang.fr': 'Francès',
  'lang.de': 'Alemany',
  'lang.it': 'Italià',
  'lang.eu': 'Basc',
  'lang.gl': 'Gallec',
  'lang.zh': 'Xinès',
  'lang.other': 'Altres',
  'lang.vi': 'Vietnamita',
  'lang.ja': 'Japonès',
  'lang.ko': 'Coreà',
  'lang.ru': 'Rus',
  'lang.ro': 'Romanès',
  'lang.ar': 'Àrab',
  'lang.tr': 'Turc',
  'lang.pl': 'Polonès',
  'lang.ms': 'Malai',
  'lang.ta': 'Tàmil',
  'upload.series_title_error': 'Escriu el títol de la sèrie',
  'upload.series_adult_category_error': 'Selecciona una categoria +18 per a la sèrie',
  'upload.series_created': 'Sèrie creada',
  'upload.series_create_error': 'No s’ha pogut crear la sèrie',
  'upload.err_file': 'Selecciona un fitxer de vídeo vàlid',
  'upload.err_title': 'Posa un títol',
  'upload.series_select_error': 'Selecciona o crea una sèrie',
  'upload.trailer_target_error': 'Selecciona el vídeo o sèrie del tràiler',
  'upload.price_error': 'Introdueix un preu vàlid de com a mínim 0,50 EUR.',
  'upload.adult_category_error': 'Selecciona una categoria adulta',
  'upload.success': 'Vídeo pujat correctament',
  'upload.title_h': 'Puja un vídeo',
  'upload.kind': 'Tipus de publicació',
  'upload.kind_video': 'Vídeo independent',
  'upload.kind_episode': 'Episodi d’una sèrie',
  'upload.kind_trailer': 'Tràiler públic en Shorts',
  'upload.series': 'Sèrie',
  'upload.series_select': 'Selecciona una sèrie',
  'upload.episode': 'Episodi',
  'upload.series_new_title': 'Títol d’una sèrie nova',
  'upload.series_create': 'Crear sèrie',
  'upload.series_adult': 'Sèrie +18',
  'upload.series_premium': 'Sèrie premium',
  'upload.series_adult_category': 'Categoria +18 de la sèrie',
  'upload.series_price': 'Preu per episodi i paquet (EUR)',
  'upload.trailer_for': 'El tràiler presenta',
  'upload.trailer_select': 'Selecciona vídeo o sèrie',
  'upload.video_prefix': 'Vídeo',
  'upload.file_label': 'Fitxer de vídeo (MP4, màx 1GB)',
  'upload.file_pick': 'Fes clic per seleccionar un vídeo',
  'upload.thumb_label': 'Miniatura (opcional)',
  'upload.video_title': 'Títol',
  'upload.description': 'Descripció',
  'upload.category': 'Categoria',
  'upload.is_short': 'És un Short (vertical)',
  'upload.paid_video': 'Vídeo de pagament',
  'upload.adult_content': 'Contingut +18',
  'upload.video_language': 'Idioma del vídeo',
  'upload.individual_price': 'Preu per veure aquest vídeo (EUR)',
  'upload.paid_video_help': 'L’espectador comprarà accés permanent només a aquest vídeo. El preu mínim és 0,50 EUR.',
  'upload.adult_category': 'Categoria adulta',
  'upload.uploading': 'Pujant {n}%',
  'upload.submit': 'Puja vídeo',
  'user.followers': 'seguidors',
  'user.following': 'seguits',
  'user.follow': 'Seguir',
  'user.chat_open': 'Xatejar',
  'user.request_sent': 'Sol·licitud enviada',
  'user.send_message': 'Enviar missatge',
  'user.followers_title': 'Seguidors',
  'user.following_title': 'Seguits',
  'user.unfollow': 'Deixar de seguir',
  'user.request_title': 'Sol·licitud de xat',
  'user.request_subtitle': 'Només pots enviar un missatge. Si accepta la sol·licitud, sereu amics i podreu xatejar.',
  'user.request_placeholder': 'Escriu el teu missatge...',
  'user.request_send': 'Enviar sol·licitud',
  'shorts.login_for_like': 'Inicia sessió per donar M\'agrada',
  'watch.share_copied': 'Enllaç copiat',
  'watch.delete_confirm': 'Eliminar aquest comentari?',
  'ad.skip_in': 'Omet en {n}s',
  'ad.skip': 'Omet anunci',
  'watch.share': 'Comparteix',
  'friends.share_video': 'Comparteix un vídeo',
  'friends.send': 'Enviar',
  'watch.comments': 'Comentaris',
  'watch.write_comment': 'Escriu un comentari...',
  'watch.publish': 'Publica',
  'watch.login_to_comment': 'Cal iniciar sessió per comentar.',
  'watch.login_btn': 'Entra per comentar',
  'watch.no_comments': 'Encara no hi ha comentaris.',
  'watch.related': 'Relacionats',
  'nav.trending': 'Tendències',
  'friends.follow_option_only_follow': 'Seguir',
  'friends.follow_option_friends': 'Amics',
  'watch.like': 'M\'agrada',
  'watch.views_short': '{n} visualitzacions',
  'shorts.empty.title': 'Encara no hi ha Shorts',
  'shorts.empty.subtitle': 'Puja un vídeo curt per estrenar la secció.',
  'shorts.share': 'Comparteix',
  'auth.continue_google': 'Continua amb Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Preu (€)',
  'upload.err_select': 'Selecciona un vídeo',
  'profile.upload_btn': 'Pujar vídeo',
  'profile.tab_videos': 'Els meus vídeos ({n})',
  'profile.tab_history': 'Historial',
  'profile.tab_recos': 'Recomanacions',
  'profile.no_videos': 'Encara no has pujat cap vídeo.',
  'profile.no_history': 'Encara no has vist cap vídeo.',
  'profile.no_recos': 'Mira alguns vídeos per rebre recomanacions.',
  'profile.likes': 'M\'agrades',
  'profile.views': 'visualitzacions',
  'wallet.title': 'Cartera',
  'wallet.rate_label': 'Taxa',
  'wallet.min_label': 'Mínim retirada',
  'wallet.amount_label': 'Quantitat a retirar',
  'wallet.withdraw_btn': 'Sol·licitar retirada',
  'wallet.history_title': 'Històric de sol·licituds',
  'wallet.success': 'Sol·licitud creada',
  'wallet.bad_amount': 'Quantitat no vàlida',
  'wallet.per_view': '{rate} {cur}/visualització',
  'admin.title': 'Administració',
  'admin.stats.users': 'Usuaris',
  'admin.stats.videos': 'Vídeos',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Visualitzacions',
  'admin.tab.videos': 'Vídeos',
  'admin.tab.ads': 'Anuncis',
  'admin.tab.users': 'Usuaris',
  'admin.tab.withdrawals': 'Retirades',
  'admin.tab.config': 'Configuració',
  'admin.tab.translations': 'Idiomes',
  'tbl.title': 'Títol',
  'tbl.creator': 'Creador',
  'tbl.category': 'Categoria',
  'tbl.type': 'Tipus',
  'tbl.views': 'Views',
  'tbl.likes': 'Likes',
  'tbl.status': 'Estat',
  'tbl.actions': 'Accions',
  'tbl.placement': 'Posició',
  'tbl.advertiser': 'Anunciant',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Clicks',
  'tbl.active': 'Actiu',
  'tbl.name': 'Nom',
  'tbl.email': 'Correu',
  'tbl.role': 'Rol',
  'tbl.wallet': 'Cartera',
  'tbl.amount': 'Quantitat',
  'tbl.date': 'Data',
  'tbl.user': 'Usuari',
  'video.video': 'Vídeo',
  'video.short': 'Short',
  'action.show': 'Publicar',
  'action.hide': 'Ocultar',
  'action.delete_confirm_video': 'Eliminar vídeo?',
  'ad.create_h': 'Crear anunci',
  'ad.title_label': 'Títol',
  'ad.image_label': 'URL imatge',
  'ad.target_label': 'URL destí',
  'ad.advertiser_label': 'Anunciant',
  'ad.placement_label': 'Posicionament',
  'ad.placement.banner': 'Banner (lloc web)',
  'ad.placement.preroll': 'Pre-roll (abans del vídeo)',
  'ad.placement.overlay': 'Overlay (dins del vídeo)',
  'ad.active': 'Actiu',
  'ad.create_btn': 'Crear',
  'ad.success_create': 'Anunci creat',
  'ad.delete_confirm': 'Eliminar anunci?',
  'users.make_admin': 'Fer admin',
  'users.remove_admin': 'Treure admin',
  'wd.approve': 'Aprovar',
  'wd.reject': 'Rebutjar',
  'wd.mark_paid': 'Marcar pagat',
  'wd.empty': 'Sense sol·licituds',
  'cfg.title': 'Configuració de pagaments',
  'cfg.rate_label': 'Pagament per visualització ({cur})',
  'cfg.min_label': 'Mínim per retirar ({cur})',
  'cfg.currency': 'Moneda',
  'cfg.save': 'Desar',
  'cfg.saved': 'Configuració desada',
  'trans.title': 'Idiomes i traduccions',
  'trans.intro': 'Puja un fitxer JSON amb traduccions per a qualsevol codi d\'idioma (p.ex. ja, pt, zh). El fitxer ha de contenir un mapatge pla de clau → text.',
  'trans.code_label': 'Codi d\'idioma (p.ex. ja, pt-BR, zh)',
  'trans.name_label': 'Nom (en aquest idioma)',
  'trans.file_label': 'Fitxer JSON de traduccions',
  'trans.upload': 'Pujar',
  'trans.uploaded': 'Traduccions desades',
  'trans.delete': 'Eliminar',
  'trans.delete_confirm': 'Eliminar aquest idioma?',
  'trans.builtin': 'Integrat',
  'trans.custom': 'Personalitzat',
  'trans.empty_custom': 'Encara no hi ha idiomes personalitzats.',
  'common.cancel': 'Cancel·la',
  'common.loading': 'Carregant...',
  'common.too_fast': 'Massa ràpid, espera un moment',
  'time.few_seconds': 'fa uns segons',
  'time.min': 'fa {n} min',
  'time.h': 'fa {n} h',
  'time.d': 'fa {n} d',
  'time.w': 'fa {n} setm',
  'time.mo': 'fa {n} mes',
  'time.y': 'fa {n} any',
  'brand.tagline': 'Vídeos curts. Creadors reals.',
  'live.section': 'En directe',
  'live.start': 'Comença un directe',
  'live.end': 'Acaba el directe',
  'live.join': 'Entra en directe',
  'live.chat_placeholder': 'Escriu un missatge...',
  'live.diamond': 'Diamant',
  'live.buy_access': 'Compra accés',
  'live.save_recording': 'Guardar enregistrament',
};
